import { render } from "./DeviceListV2.vue?vue&type=template&id=2c3d3b1c&scoped=true"
import script from "./DeviceListV2.vue?vue&type=script&lang=js"
export * from "./DeviceListV2.vue?vue&type=script&lang=js"

import "./DeviceListV2.vue?vue&type=style&index=0&id=2c3d3b1c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3d3b1c"]])

export default __exports__